"use client";

import { c as _c } from "react/compiler-runtime";
import type { Entry } from "contentful";
import type { TrustpilotRating } from "@/services/TrustpilotClient";
import type { TypeFooterSkeleton } from "@/types/contentful/generated";
import { FooterView } from "./FooterView";
interface Props {
  initialData: Entry<TypeFooterSkeleton, undefined, string>;
  reviews: TrustpilotRating | null;
}
export function FooterClient(t0) {
  const $ = _c(3);
  const {
    initialData,
    reviews
  } = t0;
  let t1;
  if ($[0] !== initialData.fields || $[1] !== reviews) {
    t1 = <FooterView fields={initialData.fields} reviews={reviews} />;
    $[0] = initialData.fields;
    $[1] = reviews;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}